import React, { Component } from 'react';
import axios from 'axios';
import { config } from '../../../../utils/domain_config';
import { Row, Col } from 'reactstrap';
import './style.css';
import Loader from './../../loader/loader';
import history from '../../../../utils/history';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { sendData } from '../../../../analytics/sendData';

class Login extends Component {
    constructor(props) {
        super(props);
        const countryCode = {
            'ee': 372,
            'es':34,
            'fr':33,
            'gr':30,
            'eg': 20,
            'nl':31
        }
        this.state = {
            msisdn: countryCode[config.lang],
            isValid: false,
            errorMessage: '',
            domain: window.location.host
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeMsisdn = this.onChangeMsisdn.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.callAuthenticate = this.callAuthenticate.bind(this);
    }

    isValid() {
        if (this.state.msisdn == '') {
            this.setState({
                isValid: false,
                errorMessage: "Phone number is required."
            });
            return false;
        }
        return true;
    }

    onChangeMsisdn(e) {
        const { value, maxLength, name } = e.target;
        const truncatedValue = value.slice(0, maxLength);
        this.setState({ [name]: truncatedValue });
    }

    onKeyUp(e) {
        if (e.keyCode == 13) {
            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.callAuthenticate({
                    msisdn: this.state.msisdn
                });
            }
        }
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.isValid()) {
            this.setState({ isValid: true, errorMessage: '' });
            this.callAuthenticate({
                msisdn: this.state.msisdn

            });
        }
    }

    componentDidMount(){
        if (JSON.parse(sessionStorage.getItem('loggedIn')) && JSON.parse(sessionStorage.getItem('loggedIn')).loggedIn){
            history.push({
                pathname: '/'
            });
        }
        else sendData('', '', 'viewed', { page: 'login'});

    }

    callAuthenticate(data) {
        // this.props.show();
        
        axios.get(`http://de-mcb-api.sam-media.com/mcb/api/v2/validate-access/sam?msisdn=${data.msisdn}&domain=${this.state.domain}`)
            .then((response) => {
                // this.props.hide();
                if (response.data.state == 'success') {
                    sessionStorage.setItem('loggedIn', JSON.stringify({ loggedIn: true }));
                    sessionStorage.setItem('uid', JSON.stringify({ uid: response.data.payload.token }));
                    sessionStorage.setItem('rockmanId', response.data.payload.rockmanId);
                    history.push({
                        pathname: '/'
                    });
                }
                else {
                    history.push({
                        pathname: '/accessDenied'
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                history.push({
                    pathname: '/accessDenied'
                });
            });
    }

    render() {
        return (
            <div className="login animated fadeIn">
                <Row className="justify-content-center">
                    <Col>
                        <Row className="login-page-header">
                            <div className="login-page-header-child">
                                <img className="login-page-logo" src={require('./../../../assets/images/Logo.png')} alt="MobioAstro" width="125px" />
                            </div>
                        </Row>
                        <Row className="login-page-content">
                            <h1>
                                <FormattedMessage id="areYouAlreadyCheckAstro"
                                    defaultMessage="Are you already a member of CheckAstroNow?"
                                     />
                            </h1>
                            <p>
                                <FormattedMessage id="thenConfirm"
                                    defaultMessage="Then confirm your mobile number and get unlimited access to all our services!"
                                />
                            </p>

                            <div className="login-page-mobile_num">
                                <input autoFocus type="number" name="msisdn" maxLength="15" value={this.state.msisdn} onChange={this.onChangeMsisdn} onKeyUp={this.onKeyUp} className="LoginRoute-number" />
                                <button type="submit" onClick={this.onSubmit} className="LoginRoute-button-CheckAstro">
                                    <FormattedMessage id="login"
                                        defaultMessage="Login"
                                    />
                            <i className="icon-back"></i>
                                </button>
                            </div>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/checkastronow/components/screens/login/login.js